import { combineReducers } from 'redux';
import { IApplicationState } from 'store/state/app-state';
import { SettingReducer } from './setting-reducer';
import { GeneralReducer } from './general-reducer';

const rootReducer = combineReducers<IApplicationState>({
    Setting: SettingReducer,
    GeneralData: GeneralReducer,
});

export default rootReducer;
